import { Injectable, inject } from '@angular/core';
import { FormTrackerService } from '../common/form-tracker.service';
import { BroadCastChannelService } from '../broadcast/broad-cast-channel.service';
import { CommonService, TranslationService } from '@waseel-asp/tpa-waseel-lib-staging';
import { SYSTEM_CONST } from '../../constants/system-constants.model';
import { LanguageType } from '../../constants/language-eum';

@Injectable({ providedIn: 'root' })
export class LanguageToggleService {
	private formTrackerService = inject(FormTrackerService);
	private broadcastService = inject(BroadCastChannelService);
	private commonService = inject(CommonService);
	private translation = inject(TranslationService);


	switchLanguage(newLang: LanguageType, currentLang?: LanguageType) {
		if (currentLang && currentLang === newLang) return;

		const localDirty = this.formTrackerService.isDirty();
		this.broadcastService.anyTabDirty((remoteDirty) => {
			if (localDirty || remoteDirty) {
				if (localDirty && !remoteDirty) {
					this.showDirtyMessage("COMMON.UNSAVED_CHANGES_LANGUAGE_SWITCH", newLang);
					return;
				} else if (remoteDirty || (localDirty && remoteDirty)) {
					this.showDirtyMessage("COMMON.UNSAVED_CHANGES_LANGUAGE_SWITCH_TABS", newLang);
					return;
				}
			} else
				this.broadcastService.reloadAllTabs(newLang);
		});
	}

	private showDirtyMessage(key: string, lang: LanguageType) {
		this.commonService.confirmDialodMessage({
			title: SYSTEM_CONST.CONFIRM,
			message: this.translation.instant(key)
		}).afterClosed().subscribe(result => {
			if (result) {
				this.formTrackerService.disableBeforeUnloadGuard();
				this.broadcastService.reloadAllTabs(lang as LanguageType);
			}
		});
	}
}
